import { render } from "./layout1.vue?vue&type=template&id=2b72307c&scoped=true"
import script from "./layout1.vue?vue&type=script&lang=js"
export * from "./layout1.vue?vue&type=script&lang=js"

import "./layout1.vue?vue&type=style&index=0&id=2b72307c&lang=scss&scoped=true"
import "./layout1.vue?vue&type=style&index=1&id=2b72307c&lang=scss"
import "./layout1.vue?vue&type=style&index=2&id=2b72307c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b72307c"]])

export default __exports__